import React from "react";

export default function Presentation(){

    return(

        <section id="presentation" style={{minHeight: '100vh', overflow: 'auto',padding: '3em 0'}}>
            <div className="container">
                <div className="panel panel-default">
                    <div className="panel-heading text-center">
                        <h1>PRÉSENTATION</h1>
                    </div>
                    <div className="panel-body">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="col-md-3 center-block">
                                    <img className="img-responsive img-circle"
                                        src="resources/img/laurent montagner presentation.jpg" />
                                </div>
    
                                <div className="col-md-9" style={{fontStyle: 'italic'}}>
                                    <p>&#160;&#160;&#160;&#160;&#160;&#160;Je suis né dans le
                                        Sud-Ouest de la France, dans le Gers, pays du bon vivre, de
                                        l'agriculture, du foie gras, de l’armagnac et patrie de
                                        d’Artagnan.</p>
                                    <p>Bercé, nourri et élevé aux bons grains de la campagne
                                        gasconne.</p>
                                    <br />
                                    <p>&#160;&#160;&#160;&#160;&#160;&#160;Tout se passe bien
                                        jusqu'à l’âge de 4 ans où frappé d’une grave maladie des reins,
                                        je suis hospitalisé d’urgence à l’hôpital des enfants de
                                        Bordeaux où j’ai été suivi par le professeur J-M Guillard, un
                                        homme extraordinaire.</p>
                                    <p>
                                        Mais j’ai également eu cette chance d’avoir comme père<span
                                            style={{fontWeight: 'bold'}}> Jacques Montagner</span>, qui, dans
                                        un premier temps, sans le savoir m’a, je pense, permis de
                                        surmonter cette épreuve et de gagner face à la maladie.
                                    </p>
                                    <p>J'oscillais entre la vie et la mort durant quelques mois
                                        puis, petit à petit et année après année, mes séjours à
                                        l’hôpital s’espaçaient. Jusqu’au jour où, un ami de mes parents
                                        leur conseilla de m’amener voir un Magnétiseur.</p>
                                    <p>Et c’est ce jour là que mon père apprit par le
                                        magnétiseur qui me traitait, que lui aussi avait cette
                                        fabuleuse faculté de soulager, de guérir, tout simplement
                                        d’aimer l’autre.</p>
                                    <br />
                                    <p>&#160;&#160;&#160;&#160;&#160;&#160;En ce qui me
                                        concerne, je me suis laissé porter par la vie à explorer divers
                                        horizons professionnels tout aussi passionnants et
                                        enrichissants les uns que les autres, jusqu’au jour où une amie
                                        me parle de son frère qui a de gros soucis avec un psoriasis
                                        qui lui pourrit la vie depuis plusieurs années.</p>
                                    <p>Alors qu’à ce moment là de ma vie j’étais loin de vouloir
                                        faire le magnétiseur, je ne sais pas, je ne peux pas expliquer
                                        pourquoi ce jour là j’ai dit à cette amie: «Si ça ne t’ennuie
                                        pas, j’aimerais bien essayer quelque chose sur ton frère pour
                                        son psoriasis»</p>
                                    <p>Elle lui en parla, il accepta d’essayer.</p>
                                    <p>Je lui fis 3 séances rapprochées.</p>
                                    <p>Il eut une réaction où son psoriasis sortit encore plus.</p>
                                    <p>(Processus normal de guérison tout comme l’eczema).</p>
                                    <br /> <br />
                                    <p>Ensuite, après ces 3 premières séances, son psoriasis,
                                        après être sorti, a commencé à sécher jusqu'à disparaître
                                        complètement.</p>
                                    <br />
                                    <p>
                                        <span style={{fontSize: '20px', fontStyle: 'normal'}}>Ce
                                            jour là, j’ai pris conscience que ma vie allait changer.</span>
                                    </p>
                                </div>
    
                            </div>
                        </div>
    
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="page-header">
                                    <h2>
                                        Témoignagne de Jacqueline
                                        DURON&#160;&#160;&#160;&#160;&#160;&#160;<small>PARIS
                                            LE : 15 MAI 2013</small>
                                    </h2>
                                </div>
    
                                <p>&#160;&#160;&#160;&#160;&#160;&#160;" Ayant eu des
                                    problemes de santé suite a la prise de retraite j' ai
                                    naturellement , et avec bonheur, fais appel à laurent MONTAGNER,
                                    fils de mon collégue Jacques décédé il y a quelques années.J'ai
                                    pratiqué le magnétisme professionnellement pendant de nombreuses
                                    années et je ressens les énergies qui sont dispensées par les
                                    bons magnétiseurs. Je dois dire que laurent a beaucoup développé
                                    ses facultés au cours des derniéres années..</p>
                                <br />
                                <p>&#160;&#160;&#160;&#160;&#160;&#160;Opérée récemment d'un
                                    genou je ne pouvais plus marcher, les douleurs étant
                                    extrèmements fortes. Laurent était en déplacement, je n'ai pu
                                    bénéficier de ses soins que quelques jours aprés l'opération :
                                    Le jour meme où il m'a traité par imposition des mains
                                    l'amélioration a été spectaculaire, non seulement pour le genou
                                    mais aussi pour les vertiges provoqués par le traitement
                                    médicamenteux suivant l'opération, et mon sommeil s'en est
                                    trouvé amélioré par le meme coup. Je n'ai meme pas besoin de
                                    réeducation.</p>
                                <br />
                                <p>&#160;&#160;&#160;&#160;&#160;&#160;Outre ses qualités de
                                    thérapeute je peux aussi témoigner de ses qualités morales. Sa
                                    bienveillance, sa générosité, son désir profond d'aider et de
                                    soigner, son intégrité, son humilité pas toujours de mise chez
                                    les thérapeutes font de lui quelqu'un de different et d'
                                    authentique..."</p>
                                <hr />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="col-md-4 center-block">
                                    <a
                                        href="https://www.amazon.fr/Magnétisme-guérison-témoignages-conseils-pratiques/dp/2733914006"
                                        target="_blank"> <img className="img-responsive" alt="temoignage"
                                        src="resources/img/livrelm.jpg" />
                                    </a>
                                </div>
    
                                <div className="col-md-6" style={{fontStyle: 'italic'}}>
                                    <p>Merci à Colette Mesnage, d'avoir prit le temps d ouvrir
                                        une fenêtre sur cette profession fascinante, passionnante,
                                        naturelle, voire même parfois, inquiétante pour certaines
                                        personnes, mais ô combien efficace sur certaines
                                        pathologies.......</p>
                                </div>
                                <div className="col-lg-2"></div>
    
                            </div>
                        </div>
                    </div>   
    
                </div>
            </div>
        </section>
        
    )


}